import Header from '../components/mainComponents/Header'
import Feature from '../components/subComponents/Feature'
import ContentLanding from '../components/mainComponents/ContentLanding'
import MainFooter from '../components/mainComponents/MainFooter'
// import MeetingAlert from '../components/subComponents/MeetingAlert'
import lake from '../images/lake photos/new landing pic.jpeg'

const Landing = ({req}) => {
  return (
    <div className="text-gray-600 body-font">
    {/* <MeetingAlert /> */}
    <Header req={req} />
    <Feature image={lake} alt={'Clubhouse Picture'}  />
    <ContentLanding />
    <MainFooter />
    </div>
  )
}

export default Landing